<template>
<div class="donate-choice-wrapper" :class="wrapperClasses">
  <product-donate-type v-model="donateType" :product="product" v-if="showDonateType" />

  <div class="block-title">{{ title }}</div>

  <div class="product-donate-choice">

    <div class="donate-item" :class="{active: amount == choice && amount > 0, [classes]: true}" v-for="choice in config.choices">
      <label class="btn">
        <input type="radio" name="amount" v-model="amount" :value="choice" /> {{ choice | comma }} บาท
      </label>
    </div>
    <div class="donate-item donate-item--custom" :class="{active: isCustomAmountActive, [classes]: true}" v-if="custom && showCustomAmountButton">
      <label class="btn">
        <input type="radio" name="amount" v-model="amount" :value="0" /> ระบุจำนวน
      </label>
    </div>

  </div>

  <div class="donate-item-amount" :class="{active: amount === 0}" v-if="custom && amount === 0">
    <label>
      ระบุจำนวนเงิน (บาท)
      <input type="radio" name="amount" v-model="amount" value="0" />
      <input class="form__text" type="number" placeholder="หรือระบุจำนวนเงินตามใจคุณ" autocomplete="off" v-model="customAmount" @focus="customAmountFocus" @keyup="customAmountKeyUp" @blur="customAmountUnfocus" ref="inputCustomAmount" />
    </label>
    <div class="alert alert--error" v-show="$v.$errors['customAmount'].minimum">จำนวนเงินขั้นต่ำ {{ product.originalPrice }} บาท</div>
  </div>

</div>
</template>

<script>
import ProductDonateType from '@/components/ProductDonateType'

export default {
  name: 'ProductDonateChoice',

  components: {
    ProductDonateType
  },

  props: {
    title: {
      type: String,
      default: 'เลือกจำนวนเงิน'
    },
    product: {
      type: Object,
      required: true
    },
    choices: {
      type: Array,
      default: () => {
        return [100]
      }
    },
    minimum: {
      type: Number,
      default: 100
    },
    custom: {
      type: Boolean,
      default: true
    },
    defaults: {
      type: Number,
      default: 500
    },
    wrapperClasses: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    showDonateType: {
      type: Boolean,
      default: true
    },
    showCustomAmountButton: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    actualAmount () {
      return this.customAmount
    },

    config () {
      return this.donateData[this.donateType]
    },

    isCustomAmountActive () {
      return parseInt(this.amount, 10) === 0
    }
  },

  data () {
    return {
      donateData: null,
      donateType: 'onetime',
      customAmount: '',
      customSelected: false,
      amount: 1000,
      $v: null
    }
  },

  created () {
    this.initDonateData()
    this.initChoices()
    this.initValidator()
    this.emit(this.amount)
  },

  methods: {
    initValidator () {
      this.$v = this.$validator.init(this, {
        customAmount: { minimum: this.product.originalPrice, dependOn: { field: 'amount', value: 0 } }
      })
    },

    initDonateData () {
      if (this.defaultDonateType) {
        this.donateType = this.defaultDonateType
      }

      if (this.product) {
        this.product.originalPrice = this.product.price

        this.donateData = {
          onetime: {
            choices: [],
            customAmount: null,
            default: 0
          },
          monthly: {
            choices: [],
            customAmount: null,
            default: 0
          }
        }
        if (this.product.meta.donation_amount_onetime) {
          this.donateData.onetime.choices = this.product.meta.donation_amount_onetime.split(',')
        }
        if (this.product.meta.donation_amount_default_onetime) {
          this.donateData.onetime.default = parseInt(this.product.meta.donation_amount_default_onetime)
        }
        if (this.product.meta.donation_custom_amount_onetime) {
          this.donateData.onetime.customAmount = true
        }

        if (this.product.meta.donation_amount_monthly) {
          this.donateData.monthly.choices = this.product.meta.donation_amount_monthly.split(',')
        } else if (this.donateData.onetime.choices) {
          this.donateData.monthly.choices = JSON.parse(JSON.stringify(this.donateData.onetime.choices))
        }
        if (this.product.meta.donation_amount_default_monthly) {
          this.donateData.monthly.default = parseInt(this.product.meta.donation_amount_default_monthly)
        } else if (this.donateData.onetime.default) {
          this.donateData.monthly.default = this.donateData.onetime.default
        }
        if (this.product.meta.donation_custom_amount_monthly) {
          this.donateData.monthly.customAmount = true
        }
      }
    },

    initChoices () {
      this.amount = this.config.default
    },

    customAmountFocus () {
      this.previousAmount = this.amount
      if (!this.customAmount) {
        this.amount = 0
      }
    },

    customAmountKeyUp () {
      this.amount = 0
      if (this.customAmount !== '') {
        this.customAmount = parseInt(this.customAmount)
        if (isNaN(this.customAmount)) {
          this.customAmount = 0
        }
      }
      this.emit(this.customAmount)
    },

    customAmountUnfocus () {
      if (this.customAmount === '') {
        this.restoreChoice()
      }
    },

    restoreChoice () {
      const index = this.config.choices.indexOf(this.previousAmount)
      if (index >= 0) {
        this.amount = this.previousAmount
      } else {
        this.amount = this.config.default
      }
    },

    validate () {
      this.$forceUpdate()
      if (!this.$v.validate()) {
        this.$utils.scrollToFirstErrors()
        return false
      }
      return true
    },

    emit (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  watch: {
    amount: function (newValue) {
      if (newValue > 0) {
        this.customAmount = ''
        this.emit(parseInt(newValue))
      } else {
        this.emit(parseInt(this.customAmount))
        this.$nextTick(() => {
          this.$refs.inputCustomAmount.focus()
        })
      }
    },

    donateType () {
      if (this.customAmount === '') {
        this.restoreChoice()
      }
    }
  }
}
</script>

<style scoped lang="scss">


.donate-choice-wrapper {
  // padding: 20px 0;
  .block-title {
    margin-bottom: 10px;
    font-size: 1.3em;
    line-height: 1.5em;
    color: #000;
    font-weight: 400;
  }
  label input[type=radio] {
    position: absolute;
    clip: rect(0,0,0,0);
    pointer-events: none;
  }
}

.product-donate-choice {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  flex-wrap: -webkit-flex-wrap;
  justify-content: space-between;

  .donate-item {
    width: 48%;
    overflow: hidden;

    &--custom {
      width: 100%
    }

    &.col-1-4 {
      @media (min-width: 480px) {
        width: 24%;
      }
    }

    &.col-1-5 {
      @media (min-width: 480px) {
        width: 19%;

      }
    }
  }
}

.donate-item {
  .btn {
    background: #fff;
    color: #2F2F2F;
    font-size: 1.2em;
    font-weight: 400;
    border: 2px solid #C2C2C2;
    min-height: 70px;
    margin-bottom: 10px;
    line-height: 70px;
    padding: 0 2%;
    min-width: auto;
    box-shadow: none;
    &:hover {
      color: #fff;
      background: #F8941D;
      border: 2px solid #F8941D;
    }
  }
  &.active {
    .btn {
      color: #fff;
      background: #F8941D;
      border: 2px solid #F8941D;
      font-weight: 500;
    }
  }
}

.form__text {
  &--line {
    border: none;
    border-radius: 0;
    border-bottom: 2px solid #F8941D;
  }
}

.donate-item-amount {
  max-width: 100%;
  margin: 10px auto 0;
  @media (min-width: 480px) {
    max-width: 80%;
  }
  .form__text {
    margin-top: 0;
  }
}


.product-choice {
  font-size: 0.9em;
  text-align: left;

  .selected {
    color: #000;
    text-transform: uppercase;
  }


  .specific {
    .choice {
      list-style: none;
      padding: 0;
      margin: 5px 0;

      .item { display: inline-block; }

        .option {
          display: inline-block;
          color: #000;
          padding: 0 5px;
          display: inline-block;
          background: #fff;
          border: 1px solid #C993C1;
          border-radius: 5px;
          width: 35px;
          font-size: 0.8em;
          line-height: 2em;
          text-align: center;
          text-transform: uppercase;
          cursor: pointer;

          &.active,
          &:hover {
            color: #fff;
            background: #C993C1;
            display: inline-block;
            text-decoration: none;
          }
          &.disable {
            opacity: 0.5;
            color: #999;
            background: #fff;
            border: 1px solid #ccc;
            cursor: not-allowed;
          }
        }
      }

      // ** Choose color
      &.-color {
        .choice {
          .option {
            background: #ccc;
            text-indent: -999em;
            width: 30px;

            &.-white { background: #fff; }
            &.-black { background: #000; }
            &.-blue { background: blue; }

            &.active {
              border: 2px solid #c993c1;
            }
          }
        }
      }

    }


}
</style>



// WEBPACK FOOTER //
// ProductDonateChoice.vue?472f7dcc